module.exports = __webpack_public_path__ + "img/img_27.d0668427.png";